// removed by extract-text-webpack-plugin
module.exports = {"modalLoading":"qempo_CancelModal_modalLoading-2wzlK4x","cancelOrderModal":"qempo_CancelModal_cancelOrderModal-2HZn_h7","title":"qempo_CancelModal_title-3xTRfQK","btn":"qempo_CancelModal_btn-3wlP3jV"};


//////////////////
// WEBPACK FOOTER
// ./src/modules/order/Purchase/components/CancelModal/CancelModal.scss
// module id = 1751
// module chunks = 0